module.exports = __webpack_public_path__ + "img/orgDetail_2.b637b85a.png";